<template>
  <div class="top-bar">
    <v-container class="top-bar-container">
      <v-spacer></v-spacer>
      <div class="top-bar-right">
        <span class="call-label">{{ $t('topbar.call') }}</span>
        <a href="tel:+37379088588" class="phone-link">+37379088588</a>
        <span class="separator">|</span>
        <a href="#" class="social-link">{{ $t('topbar.facebook') }}</a>
        <a href="#" class="social-link">{{ $t('topbar.instagram') }}</a>
        <a href="#" class="social-link">{{ $t('topbar.whatsapp') }}</a>
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'TopBar'
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@300;400&display=swap');

.top-bar {
  background: #1CA5BE;
  height: 30px;
  width: 100%;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.top-bar-container {
  display: flex;
  align-items: center;
  height: 100%;
  max-width: 1400px !important;
}

.top-bar-right {
  display: flex;
  align-items: center;
  gap: 22px;
}

.call-label {
  font-family: "IBM Plex Mono", monospace;
  color: rgb(241, 241, 241);
  font-size: 12px;
  font-weight: 400;
  letter-spacing: -0.01em;
  line-height: 28.6px;
  text-transform: uppercase;
}

.phone-link {
  font-family: "IBM Plex Mono", monospace;
  color: rgb(241, 241, 241);
  font-size: 12px;
  font-weight: 400;
  text-decoration: underline;
  letter-spacing: -0.01em;
  line-height: 28.6px;
  text-transform: uppercase;
  transition: .3s;
}

.phone-link:hover {
  color: #2F2F2F;
}

.separator {
  color: #F1F1F1;
  font-size: 12px;
}

.social-link {
  font-family: "IBM Plex Mono", monospace;
  color: #F1F1F1;
  font-size: 12px;
  font-weight: 400;
  text-decoration: none;
  letter-spacing: -0.01em;
  line-height: 28.6px;
  text-transform: uppercase;
  transition: .3s;
}

.social-link:hover {
  color: #2F2F2F;
}

/* Responsive */
@media (max-width: 960px) {
  .top-bar-right {
    gap: 12px;
  }
}

@media (max-width: 600px) {
  .call-label,
  .phone-link,
  .social-link {
    font-size: 9px;
  }

  .top-bar-right {
    gap: 8px;
  }
}
</style>
